import { Controller } from "@hotwired/stimulus"

// Управляет off-canvas сайдбаром на мобиле:
//  - open/close/toggle: класс .open на сайдбаре, .show на бэкдропе
//  - блокирует скролл body (класс .sidebar-open)
//  - закрывается по клику на бэкдроп и по Turbo-навигации
export default class extends Controller {
  static targets = ["sidebar", "backdrop"]

  connect() {
    // Гарантируем закрытое состояние при подключении (после Turbo-навигации)
    this.close()
    this._closeOnTurbo = this.close.bind(this)
    document.addEventListener("turbo:before-cache", this._closeOnTurbo)
    document.addEventListener("turbo:load", this._closeOnTurbo)
  }

  disconnect() {
    document.removeEventListener("turbo:before-cache", this._closeOnTurbo)
    document.removeEventListener("turbo:load", this._closeOnTurbo)
    // Подстраховка: не оставляем body заблокированным
    document.body.classList.remove("sidebar-open")
  }

  toggle(event) {
    if (event) event.preventDefault()
    this.isOpen ? this.close() : this.open()
  }

  open() {
    this.sidebarTarget.classList.add("open")
    if (this.hasBackdropTarget) this.backdropTarget.classList.add("show")
    document.body.classList.add("sidebar-open")
  }

  close() {
    this.sidebarTarget.classList.remove("open")
    if (this.hasBackdropTarget) this.backdropTarget.classList.remove("show")
    document.body.classList.remove("sidebar-open")
  }

  get isOpen() {
    return this.sidebarTarget.classList.contains("open")
  }
}
